import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

export interface NavLinkItem {
  to: string;
  label: string;
  icon: React.ElementType;
}

interface DesktopNavProps {
  links: NavLinkItem[];
}

const DesktopNav: React.FC<DesktopNavProps> = ({ links }) => {
  return (
    <nav className="hidden md:flex items-center h-full space-x-1">
      {links.map((link) => (
        <NavLink key={link.to} to={link.to} className="relative">
          {({ isActive }) => (
            <motion.div
              whileHover={{ y: -1 }}
              whileTap={{ scale: 0.97 }}
              className={`flex items-center px-4 h-16 text-sm font-bold transition-colors duration-200 border-b-2 ${
                isActive
                  ? 'text-accent border-accent'
                  : 'text-gray-600 border-transparent hover:text-accent'
              }`}
            >
              <link.icon className="w-5 h-5 mr-2" />
              {link.label}
              {isActive && (
                <motion.div
                  layoutId="activeIndicator"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent"
                  transition={{ duration: 0.2 }}
                />
              )}
            </motion.div>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default DesktopNav;